export const getDashboardId = (role) => {
  return role.getIn(["project", "uid"]) || role.getIn(["company", "uid"]);
};

export const getRoleName = (role) => {
  const name = role.getIn(["auth", "name"]);
  if (name.toLowerCase() === "administrator" || name.toLowerCase() === "admin") return "Admin";
  return name;
};
